import { ENDPOINT_ID } from 'components/common/Endpoint';
import { isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';

const useDetectEndpointVisibleOnScreen = (targetId) => {
  const [isIntersecting, setIntersecting] = useState(false);
  const observerRef = useRef(null);

  const endPointEle = document?.getElementById(targetId || ENDPOINT_ID);

  useEffect(() => {
    if (isEmpty(endPointEle)) return;
    observerRef.current = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) {
        setIntersecting(false);

        return;
      }

      setIntersecting(true);
    });
  }, [endPointEle]);

  useEffect(() => {
    if (isEmpty(endPointEle)) return;
    observerRef.current.observe(endPointEle);
    return () => {
      if (isEmpty(endPointEle)) return;
      observerRef.current.disconnect();
    };
  }, [endPointEle]);

  return isIntersecting;
};

export default useDetectEndpointVisibleOnScreen;
